// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hamburger[data-v-1f7bc81e] {\n    display: inline-block;\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n}\n.hamburger.is-active[data-v-1f7bc81e] {\n    transform: rotate(180deg);\n}\n", ""]);
// Exports
module.exports = exports;
